import { OrderStatesApiService } from '../../common/services/order-states.api.service';

export default {
  namespaced: true,
  state: { items: [] },
  getters: {
    getAllOrderStates: state => state.items,
    getOrderState: state => id => state.items.find(curr => curr.id === id),
  },

  mutations: {
    SET_ITEMS(state, countries) {
      state.items = countries;
    },
  },

  actions: {
    fetchAllOrderStates({ commit, dispatch }) {
      return OrderStatesApiService.getAll()
        .then(response => {
          commit('SET_ITEMS', response.getItems());
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError(_, response) {
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
